// extracted by mini-css-extract-plugin
export default {"text":"dyYUmP","avatar":"ZjaLSN","action":"Zm5q5Z","root":"sbhwti","wired":"dxA0EY","title":"Bo1yBe","subtitle":"pMMPDP"};